<template>
	<span v-if="hasMessages" class="action-container">
		<a
			href="#"
			class="action turquoise"
			@click.prevent="showMessages"
		>
			<Icon icon="mail" />
			<span v-if="newMessagesCount > 0" class="count-bubble">{{ newMessagesCount }}</span>
		</a>
	</span>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import {mapActions} from "vuex";
import {INITIATOR_APPLICANT} from "@/store/communication/conversation/messages";

export default {

	components: {
		Icon,
	},

	props: {
		job: {
			type: Object,
			required: true,
		},
	},

	computed: {
		hasMessages ()
		{
			return this.messagesCount > 0;
		},
		messagesCount ()
		{
			return this.job.communication.messagesCount;
		},
		newMessagesCount ()
		{
			return this.job.communication.newMessagesCount;
		},
	},

	methods: {
		...mapActions('communication/conversation/messages', {
			openFan: 'show',
		}),
		showMessages ()
		{
			this.openFan({
				applicantData: {
					job: this.job,
				},
				initiator: INITIATOR_APPLICANT,
				onClose: () =>
				{
					this.$emit('close');
				}
			});
		}
	}
}
</script>
